<!doctype html>
<html lang="en-us">
  <head>
    <meta charset="utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>Limber » Playground and REPL</title>
    <meta
      name="description"
      content="Limber is a playground and REPL for various web technologies, such as Svelte, Vue, Mermaid, Ember, React, and more. It also demonstrates how documentation can have live islands of different frameworks rendering all from the same document"
    />
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <!--
      This the source of truth for the ember brand variables
        https://emberjs.com/images/brand/Ember-Brand-Guidelines.pdf
    -->
    <style type="text/css">
      :root {
        --ember-brand: #e04e39;
        --ember-black: #212121;
        --ember-burnt-ember: #9b2918;
        --ember-gray: #817f7f;
        --ember-blue: #1e719b;
        --ember-faint-gray: #efebea;
        --ember-light-blue: #74b0ce;
        --ember-linen: #fdf7f6;
        --ember-yellow: #fbc840;
        --ember-white: #fdfdfd;
      }
    </style>
    <script>
      globalThis.v8 = {};
      globalThis.path = {
        resolve: (...args) => args.join("/"),
      };
    </script>
    <!--
      The editor placeholder uses this font on the first render.
      Without the preload, the browser finds the font only after it parses the CSS.
      Keep the URL in sync with the @font-face rule in app/styles/app.css.
    -->
    <link
      rel="preload"
      as="font"
      type="font/woff2"
      crossorigin
      href="https://fonts.gstatic.com/s/sourcecodepro/v30/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQtMlrTA.woff2"
    />
    <link rel="stylesheet" href="./app/styles/app.css" />
    <!-- VITE_EMBER_SSR_HEAD -->
  </head>
  <body class="syntax-dark syntax-bright">
    <div id="initial-loader">
      <style>
        body,
        html {
          margin: 0;
          padding: 0;
        }
      </style>
      <!--
        This is the App Shell
        It's sole purpose is to show something when the HTML loads (which is small and loads / is parsed fast)
        This gives the user an illusion of speed
      -->
      <div style="height: 100vh; width: 100vw; display: grid; grid-template-rows: min-content 1fr">
        <!-- header -->
        <div
          id="initial-header"
          style="background: var(--ember-black); height: 45px; width: 100%"
        ></div>

        <!-- everything else -->
        <div
          style="display: grid; grid-template-columns: auto 1fr; font-weight: bold; font-size: 24px"
        >
          <!-- editor -->
          <div
            style="
              width: 40vw;
              background: rgba(39, 39, 42);
              color: white;
              padding-right: 2px;
              display: grid;
              align-items: center;
              justify-content: end;
            "
          >
            Loading
          </div>

          <!-- preview -->
          <div
            style="
              padding-left: 2px;
              color: rgb(39, 39, 42);
              display: grid;
              align-items: center;
              justify-content: start;
            "
          >
            Limber
          </div>
        </div>
      </div>
    </div>

    <script>
      if (window.self !== window.parent) {
        window.self.document.querySelector("#initial-header").style.display = "none";
        window.self.document.querySelector("#initial-loader > div").style.gridTemplateRows = "1fr";
        window.self.document.body.classList.remove("overflow-hidden");
      }
    </script>

    <!-- VITE_EMBER_SSR_BODY -->

    <script type="module" src="./app/boot.ts"></script>
  </body>
</html>
